import React from 'react';
import NotAvailable from '../Common/NotAvailable';

interface ProviderAboutSectionProps {
  providerName: string;
  about: string | null;
}

const ProviderAboutSection: React.FC<ProviderAboutSectionProps> = ({ providerName, about }) => {
  return (
    <section className="mb-8">
      <h2 className="font-['Ovo'] text-2xl text-[#1f1f1f] uppercase mb-4">ABOUT {providerName}</h2>
      <p className="font-['Open_Sans'] text-base text-[#1f1f1f]">{about || <NotAvailable />}</p>
    </section>
  );
};

export default ProviderAboutSection;
